
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			DecimalSettings: DossierConfigService.getDecimalSettings(),
			testDialog: false,
			sending: false,
			path: [{
				to: "/settings/sales", value: this.$ct("sale/purchase")
			},     {value: this.$ct("decimals")}] as IBreadCrumb[],
		};
	},
	computed: {
		valid():boolean {
			return this.DecimalSettings.isValid();
		}
	},
	methods: {
		async save(test: boolean) {
			if (this.sending) return;
			if (!this.valid) {
				this.$wf.notify(this.$ct("error-number-invalid"), "danger", 3000, "exclamation-triangle");
				return;
			}
			try {
				this.sending = true;
				this.DecimalSettings = await DossierConfigService.saveDecimalSettings(this.DecimalSettings);
				this.$router.back();
			} catch (err) {
			}
			this.testDialog = false;
			this.sending = false;
		},
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
